module.exports = __webpack_public_path__ + "static/media/personal_media_catalog.eb1f02f0.xlsx";